import { Outlet } from "react-router-dom";
import { DashboardLayout } from "./DashboardLayout";

export function DashboardRoot() {
  return (
    <DashboardLayout>
      <Outlet />
    </DashboardLayout>
  );
}
